import axios from 'plugins/axios'

export const state = {
  information: null
}

export const getters = {
  get: (state) => {
    if (!state.information) return {}
    return state.information
  }
}

export const mutations = {
  set (state, information) {
    state.information = information
  }
}

export const actions = {
  async request ({state, commit}) {
    if (state.information) return

    let {data} = await axios.get('/shops/informations')
    commit('set', data.data)
  }
}



// WEBPACK FOOTER //
// ./client/store/shopInformation.js